import {
  Component,
  EventEmitter,
  Output,
  Input,
  HostListener,
  ElementRef,
  ViewChild,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  OnInit
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import _ from 'lodash';
import * as $ from 'jquery';
import math from 'mathjs';
import { Utils } from '../../../service/utils';
import { Constants, MillBit } from '../../../service/constants';
import { Message } from '../../../service/dialog/message.interface';
import { Cutter_, ToolContainer, Parameters_ } from '../../../service/formulas/objects';
import { Formulas } from '../../../service/formulas/formulas';
import { ConversionFormulas } from '../../../service/formulas/conversionsFormulas';
import { CommonService } from '../../../service/common.service';
import { CacheService } from 'ionic-cache';
import { ImageConstants } from '../../../service/image-constants';

declare var cordova;

enum CutWidthType {
  RADIAL_CUT_DEPTH = 'radial cut depth',
  STEPOVER = 'stepover',
  ENGAGEMENT_ANGLE = 'engagement angle'
}

@Component({
  selector: 'section-parameters',
  templateUrl: 'parameters.html',
  styleUrls: ['parameters.scss']
})
export class Parameters implements AfterViewInit, OnInit, OnChanges {
  private subscription: Subscription;
  private emit: boolean = true; // This seems to be unused. Okay to remove?
  private origin: string = undefined;
  private isApp: boolean;
  private windowsDimensions: object = undefined;
  private aggressiveFlag: boolean = false;
  private warningAlerts: boolean = false;
  public currentPath: string = '';
  public tool: Cutter_;
  public parameterTypes: number = 0;
  public rows: any[] = [];
  public columns: any[] = [];
  public Parameters: FormGroup;
  public popupVisible: object;
  public current: MillBit;
  public knob: any;
  public knobSize: number = 400;
  public adocSize: number = 0;
  public horizontalSliderHolderWidth: number = 0;
  public horizontalSliderHolderHeight: number = 0;
  public cutWidth: number = 0;
  public cutDepth: number = 0;
  public offset: number = 0;
  public adocMax: number = 32;
  public vSliderValue: number = 0;
  public stepOver: number = 0;
  public trueMax: number = 0;
  public maxRDOC: number = 0;
  public engagmentAngelKnobOptions: object;
  public toolImage: string = undefined;
  public toolImageHeight: number = undefined;
  public toolImageWidth: number = undefined;
  public knobDisabler: boolean = true;
  public mapMode: number = 1;
  public operationToolImage: string = '';
  private adoc: number = undefined;
  private adocLocked: boolean = false;
  private adocLockDisabled: boolean = true;
  private rdoc: number = undefined;
  private rdocLocked: boolean = false;
  private rdocLockDisabled: boolean = true;
  private defaultEngagementAngle: number = undefined;
  private finMessageWarning: boolean = false;

  private defaultSliderRDOC: number = undefined;
  private defaultSliderADOC: number = undefined;
  public defaultSliderADOCDisabled: boolean = true;
  public defaultSliderRDOCDisabled: boolean = true;
  private adocTicks: number = 32;
  private overlayDivideFactor: number = 2;
  private sliderMax: number = 300;
  private warningMessageOpen: boolean = false;
  public sliderDisabled: boolean = true;
  public sliderRdocDisabled: boolean = true;
  private holder: string = undefined;
  public chamferSliders: boolean = true;
  private invalidEndmillModal: boolean = false;
  private trochoidalSlotWidthChange: boolean = false;
  settingsHolder: ToolContainer;
  public showMapModeTwo: boolean = false;

  @Output() parameterChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() resetMaterial: EventEmitter<any> = new EventEmitter<any>();
  @Output() resetTool: EventEmitter<any> = new EventEmitter<any>();
  @Output() filterOperationPaths: EventEmitter<any> = new EventEmitter<any>();
  @Output() parameterChangeWithSpecificChild: EventEmitter<any> = new EventEmitter<any>();
  @Input() parameters: object;
  @ViewChild('adjusterHolder', { static: false }) elementView: ElementRef;
  @ViewChild('horizontalSlider', { static: true }) horizontalSliderView: ElementRef;
  @ViewChild('verticalSlider', { static: true }) verticalSliderView: ElementRef;
  @ViewChild('graph', { static: true }) graph: ElementRef;
  @ViewChild('teaInnerBlock', { static: false }) teaInnerBlock: ElementRef;
  @ViewChild('leftside', { static: false }) leftside: ElementRef;
  @ViewChild('toolWrapper', { static: true }) toolWrapper: ElementRef;
  @ViewChild('tea', { static: false }) tea: ElementRef;
  @ViewChild('adocSlider', { static: true }) adocSlider: ElementRef;
  @ViewChild('rdocSlider', { static: true }) rdocSlider: ElementRef;
  @ViewChild('uiknob', { static: false }) uiknob: ElementRef;
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.onResize();
  }

  constructor(
    public utils: Utils,
    private formBuilder: FormBuilder,
    public constants: Constants,
    private commonService: CommonService,
    private formulas: Formulas,
    private conversionFormulas: ConversionFormulas,
    private cache: CacheService,
    private imageConstants: ImageConstants
  ) {
    this.isApp = this.utils.isApp();
    this.toolImage = imageConstants.defaultTool;
    this.engagmentAngelKnobOptions = {
      scale: {
        enabled: true,
        type: 'dots',
        color: 'rgba(255,0,0,.2)',
        width: 2,
        quantity: 50,
        spaceWidth: 10
      },
      skin: {
        type: 'tron',
        width: 5,
        color: '#9C9C9C',
        spaceWidth: 0
      },
      readOnly: false,
      size: this.knobSize,
      animate: {
        enabled: true,
        duration: 2000,
        ease: 'exp'
      },
      startAngle: 0,
      endAngle: 360,
      unit: '%',
      barColor: 'rgba(87, 186, 133,.76)',
      trackWidth: 200,
      barWidth: 200,
      textColor: '#494B52',
      prevBarColor: 'rgba(117, 250, 102, 0.5)',
      trackColor: '#FFFFFF',
      fontSize: 'auto',
      subText: {
        enabled: true,
        text: ' ',
        color: '#494B52',
        font: 'auto'
      },
      step: 1,
      displayPrevious: true,
      min: 0,
      max: 360,
      notifyOnDragEnd: true,
      showlabels: true,
      maxCap: 180,
      dynamicOptions: true
    };

    if (this.isApp) {
      this.cache.getItem('windowsDimensions').then(windowsDimensions => {
        this.windowsDimensions = windowsDimensions;
      });
    }
    this.Parameters = this.formBuilder.group({
      engagementAngle: new FormControl(0, [
        Validators.pattern(this.constants.DECIMAL_ONLY_REGEX),
        Validators.max(180),
        Validators.min(0)
      ]),
      stepDown: new FormControl(0, [Validators.pattern(this.constants.DECIMAL_ONLY_REGEX), Validators.min(0)]),
      stepOver: new FormControl(0, [Validators.pattern(this.constants.DECIMAL_ONLY_REGEX), Validators.min(0)]),
      adocdecimal: new FormControl(0, [Validators.pattern(this.constants.DECIMAL_ONLY_REGEX), Validators.min(0)]),
      rdocdecimal: new FormControl(0, [Validators.pattern(this.constants.DECIMAL_ONLY_REGEX), Validators.min(0)]),
      stickOut: new FormControl(0, [Validators.pattern(this.constants.DECIMAL_ONLY_REGEX), Validators.min(0)]),
      stickoutPercentage: new FormControl(0, [
        Validators.pattern(this.constants.DECIMAL_ONLY_REGEX),
        Validators.min(0)
      ]),
      pitch: new FormControl(0, [Validators.pattern(this.constants.DECIMAL_ONLY_REGEX), Validators.min(0)]),
      rampAngle: new FormControl(0, [Validators.pattern(this.constants.DECIMAL_ONLY_REGEX), Validators.min(0)]),
      holeDiameter: new FormControl(0, [Validators.pattern(this.constants.DECIMAL_ONLY_REGEX), Validators.min(0)]),
      pathDiameter: new FormControl(0, [Validators.pattern(this.constants.DECIMAL_ONLY_REGEX), Validators.min(0)]),
      holeDepth: new FormControl(0, [Validators.pattern(this.constants.DECIMAL_ONLY_REGEX), Validators.min(0)]),
      effectiveDiameter: new FormControl(0),
      chamferHeight: new FormControl(0, [Validators.pattern(this.constants.DECIMAL_ONLY_REGEX), Validators.min(0)]),
      chamferWidth: new FormControl(0, [Validators.pattern(this.constants.DECIMAL_ONLY_REGEX), Validators.min(0)]),
      scallopHeight: new FormControl(0, [Validators.pattern(this.constants.DECIMAL_ONLY_REGEX), Validators.min(0)]),
      scallopWidth: new FormControl(0, [Validators.pattern(this.constants.DECIMAL_ONLY_REGEX), Validators.min(0)])
    });
    this.popupVisible = {};

    // defaults
    this.current = this.constants.getMillBit(0);
  }

  putInView = (evt: any, alignToTop: boolean) => {
    //All input fields we want to align to bottom, alightTopTop false, because it was causing styling issues when aligning to top
    let input = evt.currentTarget;
    if (this.isApp) {
      setTimeout(() => {
        input.scrollIntoView(alignToTop);
      }, 500);
    }
  };

  private matchSliderToStepDown = (stepDown: number) => {
    if (this.currentPath === 'Trochoidal Slotting') {
      this.vSliderValue = stepDown * 10 * this.overlayDivideFactor;
    } else {
      this.vSliderValue = stepDown * 10;
    }
  };

  private updateStickOut = (stickOut: number) => {
    this.Parameters.get('stickOut').patchValue(math.round(stickOut, 3), { emitEvent: false });
  };

  private updateStickoutPercentage = (stickoutPercentage: number) => {
    this.Parameters.get('stickoutPercentage').patchValue(math.round(stickoutPercentage, 3), { emitEvent: false });
  };

  private updatePitch = (pitch: number) => {
    this.Parameters.get('pitch').patchValue(math.round(pitch, 3), { emitEvent: false });
  };

  private updateRampAngle = (rampleAngle: number) => {
    this.Parameters.get('rampAngle').patchValue(math.round(rampleAngle, 3), { emitEvent: false });
  };

  private updateEngagementAngle = (angle: number) => {
    this.Parameters.get('engagementAngle').patchValue(math.round(angle, 1), { emitEvent: false });
  };

  private updateHoleDiameter = (holeDiameter: number) => {
    this.Parameters.get('holeDiameter').patchValue(math.round(holeDiameter, 3), { emitEvent: false });
  };

  private updatePathDiameter = (pathDiameter: number) => {
    this.Parameters.get('pathDiameter').patchValue(math.round(pathDiameter, 3), { emitEvent: false });
  };

  private updateHoleDepthField = (holeDepth: number) => {
    this.Parameters.get('holeDepth').patchValue(math.round(holeDepth, 3), { emitEvent: false });
  };

  private updateEffectiveDiameter = (effectiveDiameter: number) => {
    this.Parameters.get('effectiveDiameter').patchValue(math.round(effectiveDiameter, 3), { emitEvent: false });
  };

  private updateChamferHeight = (chamferHeight: number) => {
    this.Parameters.get('chamferHeight').patchValue(math.round(chamferHeight, 3), { emitEvent: false });
  };

  private updateChamferWidth = (chamferWidth: number) => {
    this.Parameters.get('chamferWidth').patchValue(math.round(chamferWidth, 3), { emitEvent: false });
  };

  private updateScallopHeight = (scallopHeight: number) => {
    this.Parameters.get('scallopHeight').patchValue(math.round(scallopHeight, 3), { emitEvent: false });
  };

  private updateScallopWidth = (scallopWidth: number) => {
    this.Parameters.get('scallopWidth').patchValue(math.round(scallopWidth, 4), { emitEvent: false });
  };

  private updateADOC = (adocdecimal: number, notifyField: boolean = true) => {
    if (!this.adocLocked) {
      let value = math.round(adocdecimal, 4);
      if (notifyField) {
        this.Parameters.get('adocdecimal').patchValue(value, { emitEvent: false });
      }

      // if adocslider and rdocslider is 0,0 position, then no tool is chosen yet
      if (!this.adocSlider['value'] && !this.rdocSlider['value'] && !this.settingsHolder.tool) {
        this.defaultSliderADOCDisabled = true;
        this.defaultSliderRDOCDisabled = true;
      } else {
        if (value !== this.adoc) {
          this.defaultSliderADOCDisabled = false;
        } else {
          this.defaultSliderADOCDisabled = true;
        }
      }
    }
  };

  private updateRDOC = (rdocdecimal: number, emitEvent: boolean = false, updateDefaults: boolean = false) => {
    if (!this.rdocLocked) {
      let value = math.round(rdocdecimal, 4);
      this.Parameters.get('rdocdecimal').patchValue(math.round(rdocdecimal, 4), { emitEvent: emitEvent });
      if (!this.adocSlider['value'] && !this.rdocSlider['value'] && !this.settingsHolder.tool) {
        this.defaultSliderADOCDisabled = true;
        this.defaultSliderRDOCDisabled = true;
      } else {
        if (updateDefaults) {
          this.rdoc = value;
        } else {
          if (value !== this.rdoc) {
            this.defaultSliderRDOCDisabled = false;
          } else {
            this.defaultSliderRDOCDisabled = true;
          }
        }
      }
    }
  };

  private updateStepOver = (stepOver: number, updateDefault: boolean = false) => {
    if (!this.rdocLocked) {
      let place = 3;
      if (this.settingsHolder.currenttoolpath && this.settingsHolder.currenttoolpath.operationName === '3D Surfacing') {
        place = 4;
      }

      if (updateDefault) {
        this.defaultSliderRDOC = stepOver;
      }
      this.Parameters.get('stepOver').patchValue(math.round(stepOver, place), { emitEvent: true });
    }
  };

  private updateStepDown = (stepDown: number, emit: boolean = true) => {
    this.Parameters.get('stepDown').patchValue(math.round(stepDown, 3), { emitEvent: emit });
  };

  private adocReset = () => {
    this.Parameters.get('adocdecimal').patchValue(this.adoc, { emitEvent: true });
    this.aggressiveFlag = false;
    this.warningAlerts = true;
    this.onVerticalSliderChange({ value: this.defaultSliderADOC }, false);
    this.adocSlider['value'] = this.defaultSliderADOC;
    this.vSliderValue = this.defaultSliderADOC;
    this.defaultSliderADOCDisabled = true;
    this.adocLocked = false;
  };

  private lockAdoc = () => {
    this.adocLocked = !this.adocLocked;
    this.sliderDisabled = this.adocLocked;
  };

  private rdocReset = () => {
    this.Parameters.get('rdocdecimal').patchValue(this.rdoc, { emitEvent: true });
    this.Parameters.get('stepOver').patchValue(this.stepOver, { emitEvent: true });
    this.rdocSlider['value'] = this.defaultSliderRDOC;
    this.aggressiveFlag = false;
    this.warningAlerts = true;
    this.onHorizontalSliderChange({ value: this.defaultSliderRDOC }, false, false);
    this.defaultSliderRDOCDisabled = true;
    this.updateEngagementAngle(this.defaultEngagementAngle);
    this.rdocLocked = false;
  };

  private lockRdoc = () => {
    this.rdocLocked = !this.rdocLocked;
    this.sliderRdocDisabled = this.rdocLocked;
  };

  getRows = (): any[] => {
    return this.rows;
  };

  getColumns = (): any[] => {
    return this.columns;
  };

  valueChange = ($event: { value: number; event: string }) => {
    if ($event.event) {
      // only change it if there is a eventType, else its autoset by some other field
      if ($event.value !== this.settingsHolder.parameters.engagementAngle) {
        // this to prevent wheel mouse event coming back multiple times
        this.updateEngagementAngle($event.value);
        this.engagementAngleChange(this.Parameters.get('engagementAngle').value);
      }
    }
  };

  onVerticalSliderChange = (
    event: any,
    notify: boolean = true,
    convert: boolean = true,
    updateCutWidth: boolean = true,
    setRdoc: boolean = true,
    showWarnings: boolean = true
  ) => {
    if (
      this.settingsHolder.currenttoolpath &&
      this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('full slotting') > -1
    ) {
      this.convertVSliderToStepDownField(event.value, false, true, updateCutWidth, setRdoc, showWarnings);
      this.updateADOC((this.Parameters.get('stepDown').value * this.settingsHolder.tool.cutterDiameter) / 100);
    } else if (
      this.settingsHolder.currenttoolpath &&
      this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('helical plunge') < 0
    ) {
      this.convertVSliderToStepDownField(event.value, notify, convert, showWarnings);
      this.setRDOC();
    } else {
      if (this.warningAlerts) {
        if (event.value === 0) {
          let message: Message = {
            title: 'No Hole Specified',
            message: 'Your hole depth must be greater than zero for the hole to exist!'
          };
          this.utils.openDialog(message, 'error');
          this.setHoleDepth(false);
        } else {
          if (event.value === 0) {
            let message: Message = {
              title: 'No Hole Specified',
              message: 'Your hole depth must be greater than zero for the hole to exist!'
            };
            this.utils.openDialog(message, 'error');
            this.setHoleDepth(false);
          } else {
            let holeDepth = (this.settingsHolder.tool.lengthOfCut * event.value) / this.trueMax;
            this.Parameters.get('stepDown').patchValue(event.value, { emitEvent: true });
            this.updateHoleDepthField(holeDepth);
            this.emitData();
          }
        }
      }
    }
    if (this.isApp && notify) {
      this.utils.apptentiveEngage('Axial Depth (Slider)');
    }
  };

  onHorizontalSliderChange = (event: any, notify: boolean = true, updateRDOC: boolean = true) => {
    this.updateStepOver(event.value);

    let roundFactor = this.formulas.emRoundFactor(this.settingsHolder.tool.cutterDiameter);
    this.cutWidth = (this.settingsHolder.tool.cutterDiameter * event.value) / 100;

    if (
      this.settingsHolder.currenttoolpath &&
      this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('finishing') > -1
    ) {
      this.cutWidth = this.finMessage(CutWidthType.RADIAL_CUT_DEPTH, this.cutWidth);
    }

    if (updateRDOC) {
      this.updateRDOC(roundFactor * math.round(this.cutWidth / roundFactor, 2), notify);
    }

    if (this.cutWidth >= this.settingsHolder.tool.cutterDiameter) {
      if (!this.warningMessageOpen) {
        this.slotMessage('RDOC');
      }
    }

    if (updateRDOC) {
      this.updateCutWidth(event.value);
    } else {
      this.updateCutWidth(event.value, this.defaultEngagementAngle);
    }

    setTimeout(() => {
      this.maxRDOCmessage();
    });

    if (this.isApp && event) {
      this.utils.apptentiveEngage('Radial Depth (Slider)');
    }
  };

  private setTheSlideBars = () => {
    if (this.isApp) {
      this.knobSize = $(this.teaInnerBlock.nativeElement).height();
    } else {
      let sliderKnobWidth = this.horizontalSliderView.nativeElement;
      $(sliderKnobWidth)
        .find('.mat-slider-wrapper')
        .width(this.horizontalSliderHolderWidth);
      let verticalSliderTrackWidth = $(sliderKnobWidth)
        .find('.mat-slider-track-wrapper')
        .height();

      let verticalSliderKnobWidth = $(this.horizontalSliderView.nativeElement)
        .find('.mat-slider-thumb')
        .height();
      let verticalSliderKnobHeight = $(this.horizontalSliderView.nativeElement)
        .find('.mat-slider-thumb')
        .width();

      $(this.verticalSliderView.nativeElement)
        .find('.mat-slider-thumb')
        .css({
          width: verticalSliderKnobWidth,
          height: verticalSliderKnobHeight
        });

      if (verticalSliderKnobWidth === 0) {
        $(this.verticalSliderView.nativeElement)
          .find('.mat-slider-thumb')
          .css({
            width: $(this.horizontalSliderView.nativeElement).find('.mat-slider-thumb')[0].offsetHeight
          });
      }

      $(this.verticalSliderView.nativeElement)
        .find('.mat-slider-track-wrapper')
        .width(verticalSliderTrackWidth);

      this.adocSize =
        this.horizontalSliderView.nativeElement.children[0].children[0].children[2].children[1].offsetWidth -
        this.horizontalSliderView.nativeElement.children[0].children[0].children[2].children[1].offsetWidth * 0.19 -
        13.8;

      this.knobSize = $(this.teaInnerBlock.nativeElement).height();

      if (this.utils.detectIE()) {
        //strict IE fixes, does not apply to other browsers

        setTimeout(() => {
          this.knobSize = $(this.teaInnerBlock.nativeElement).height();
          $('.behindKnob').height($('.behindKnobTrack').height());
          $('.knobSkinned').css({
            left: '-12%',
            top: '5%'
          });
        }, 1000);

        $(this.toolWrapper.nativeElement).css({
          height: $(this.leftside.nativeElement).height() - $(this.leftside.nativeElement).height() * 0.05 + 'px'
        });
        $(this.elementView.nativeElement).css({
          position: 'relative'
        });
      }
    }
  };

  onResize = () => {
    if (!this.isApp) {
      this.horizontalSliderHolderWidth = $(this.graph.nativeElement).width(); // 0 cause the page in mobile does not exist yet
      this.horizontalSliderHolderHeight = $(this.leftside.nativeElement).height();

      this.setTheSlideBars();
    } else {
      this.cache.getItem('windowsDimensions').then(windowsDimensions => {
        this.windowsDimensions = windowsDimensions;
        this.horizontalSliderHolderWidth = this.windowsDimensions['w']; // 0 cause the page in mobile does not exist yet
        this.horizontalSliderHolderHeight = this.windowsDimensions['h'];
        this.setTheSlideBars();
      });
    }
  };

  convertVSliderToStepDownField = (
    value: number,
    notify: boolean = true,
    updateStepDown: boolean = true,
    updateCutWidth: boolean = true,
    setRdoc: boolean = true,
    showWarnings: boolean = true
  ) => {
    if (updateStepDown) {
      this.updateStepDown((value / this.sliderMax) * 100 * this.overlayDivideFactor, false);
    }
    this.calculateStepDown(notify, updateCutWidth, setRdoc, showWarnings);
  };

  ngOnChanges(changes: SimpleChanges) {
    this.rows.length =
      (changes['adocMax'].currentValue % 1 != 0
        ? math.ceil(changes['adocMax'].currentValue * 10)
        : math.ceil(changes['adocMax'].currentValue)) * 2;
    this.Parameters.get('adocdecimal').setValidators([
      Validators.pattern(this.constants.DECIMAL_ONLY_REGEX),
      Validators.max(changes['adocMax'].currentValue),
      Validators.min(0)
    ]); // set the max to the tool
  }

  engagementAngleChange = (value: number) => {
    if (
      this.settingsHolder.currenttoolpath &&
      this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('full slotting') > -1
    ) {
      this.setSlotting(false);
    } else if (value >= 180) {
      if (!this.warningMessageOpen) {
        this.slotMessage('Engagement Angle');
      }
    } else if (value < 180 && value > 0) {
      if (
        this.settingsHolder.currenttoolpath &&
        this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('finishing') > -1
      ) {
        value = this.conversionFormulas.convertRdocToTea(
          this.finMessage(CutWidthType.ENGAGEMENT_ANGLE, value),
          this.settingsHolder.tool.cutterDiameter
        );
      }

      this.cutWidth = this.conversionFormulas.convertTeaToRdoc(value, this.settingsHolder.tool.cutterDiameter);

      // need to get wallrad from recommendations
      let recFormType = 'type1';
      let insideCornerRadiusWall = undefined;

      if (this.settingsHolder.recommendationForm) {
        if (this.settingsHolder.recommendationFields === 1) {
          insideCornerRadiusWall = this.settingsHolder.recommendationForm.get('type1').get('insideCornerRadiusOfWall')
            .value;
        } else if (this.settingsHolder.recommendationFields === 2) {
          insideCornerRadiusWall = this.settingsHolder.recommendationForm.get('type2').get('trochoidalSlotWidth').value;
          recFormType = 'type2';
        }

        if (insideCornerRadiusWall === '') {
          insideCornerRadiusWall = undefined;
        }

        if (insideCornerRadiusWall) {
          if (
            this.settingsHolder.currenttoolpath &&
            this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('trochoidal slotting') > -1
          ) {
            this.cutWidth = this.conversionFormulas.convertTeaToRdoc(
              value,
              this.settingsHolder.tool.cutterDiameter,
              insideCornerRadiusWall / 2
            );
          } else if (
            this.settingsHolder.recommendationForm
              .get(recFormType)
              .get('insideCornerType')
              .value.toLowerCase('ipm inside corner')
              .indexOf() > -1
          ) {
            this.cutWidth = this.conversionFormulas.convertTeaToRdoc(
              value,
              this.settingsHolder.tool.cutterDiameter,
              insideCornerRadiusWall
            );
          }
        }
      }

      this.updateRDOC(this.cutWidth);
      this.updateCutWidth(undefined, value); // this should recalculate the stepOver
    }
  };

  emitData = (specificChild: string = undefined) => {
    if (!this.trochoidalSlotWidthChange) {
      let data = {
        toolPath: this.settingsHolder.currenttoolpath,
        cutterDiameter: this.settingsHolder.tool ? this.settingsHolder.tool.cutterDiameter : 0,
        stickOut: this.Parameters.get('stickOut').value,
        stickoutPercentage: this.Parameters.get('stickoutPercentage').value,
        pitch: this.Parameters.get('pitch').value,
        rampAngle: this.Parameters.get('rampAngle').value,
        holeDiameter: this.Parameters.get('holeDiameter').value,
        pathDiameter: this.Parameters.get('pathDiameter').value,
        holeDepth: this.Parameters.get('holeDepth').value,
        effectiveDiameter: this.Parameters.get('effectiveDiameter').value,
        chamferHeight: this.Parameters.get('chamferHeight').value,
        chamferWidth: this.Parameters.get('chamferWidth').value,
        scallopHeight: this.Parameters.get('scallopHeight').value,
        scallopWidth: this.Parameters.get('scallopWidth').value,
        cutWidth: this.cutWidth,
        cutDepth: this.cutDepth,
        stepDown: this.Parameters.get('stepDown').value,
        stepOver: this.Parameters.get('stepOver').value,
        adocdecimal: this.Parameters.get('adocdecimal').value,
        rdocdecimal: this.Parameters.get('rdocdecimal').value,
        engagementAngle: this.Parameters.get('engagementAngle').value,
        vSliderValue: this.vSliderValue
      };

      if (!!!specificChild) {
        if (this.origin) {
          this.parameterChange.emit({ data: data, origin: this.origin });
        } else {
          this.parameterChange.emit({ data: data });
        }
      } else {
        this.parameterChangeWithSpecificChild.emit({
          specificChild: specificChild,
          data: data,
          origin: this.origin
        });
      }
    }
  };

  ngOnInit() {
    this.Parameters.get('stickOut')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          if (this.warningAlerts) {
            if (value >= this.settingsHolder.tool.overallLength) {
              let message: Message = {
                title: 'Stick-out too Far!',
                message: 'Stick-out must be less than endmill overall length!'
              };
              this.utils.openDialog(message, 'error');
            } else if (value > this.settingsHolder.tool.lengthOfCut) {
              this.updateStickoutPercentage((100 * value) / this.settingsHolder.tool.cutterDiameter);
              this.emitData('recommendations');
            } else if (value > 0) {
              let message: Message = {
                title: 'Stick-out too Close!',
                message: 'Stick-out must be greater than endmill length of cut!'
              };
              this.utils.openDialog(message, 'error');
            }
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('Stick Out (Numeric)');
          }
        }
      });

    this.Parameters.get('stickoutPercentage')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          if (this.warningAlerts) {
            if (value / 100 >= this.settingsHolder.tool.overallLength / this.settingsHolder.tool.cutterDiameter) {
              let message: Message = {
                title: 'Stick-out too Far!',
                message: 'Stick-out must be less than endmill overall length!'
              };
              this.utils.openDialog(message, 'error');
            } else if (value / 100 > this.settingsHolder.tool.lengthOfCut / this.settingsHolder.tool.cutterDiameter) {
              this.updateStickOut((value * this.settingsHolder.tool.cutterDiameter) / 100);
              this.emitData('recommendations');
            } else if (value > 0) {
              let message: Message = {
                title: 'Stick-out too Close!',
                message: 'Stick-out must be greater than endmill length of cut!'
              };
              this.utils.openDialog(message, 'error');
            }
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('Stick Out (Numeric)');
          }
        }
      });

    this.Parameters.get('chamferHeight')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          if (this.Parameters.get('effectiveDiameter').value > 0) {
            let maxChamferWidth =
              Math.floor((500 * (this.Parameters.get('effectiveDiameter').value - this.settingsHolder.tool.tip)) / 2) /
              500;
            let maxChamferHeight =
              Math.floor((500 * maxChamferWidth) / math.tan((math.PI * this.settingsHolder.tool.taper) / 180)) / 500;

            if (value >= maxChamferHeight) {
              let messageStr = 'Chamfer height must less than or equal to ' + maxChamferHeight + '\x22!';

              let message: Message = {
                title: 'Chamfer Height too Large',
                message: messageStr
              };
              if (this.warningAlerts) {
                this.utils.openDialog(message, 'error', () => {
                  this.setChamfer();
                });
              }
            }
          }

          let chamferWidth = value * math.tan((math.PI * this.settingsHolder.tool.taper) / 180);

          this.updateChamferWidth(chamferWidth);
          this.emitData('recommendations');
          if (this.isApp) {
            this.utils.apptentiveEngage('Chamfer Height (Numeric)');
          }
        }
      });

    this.Parameters.get('chamferWidth')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          if (this.Parameters.get('effectiveDiameter').value > 0) {
            let maxChamferWidth =
              math.floor((500 * (this.Parameters.get('effectiveDiameter').value - this.settingsHolder.tool.tip)) / 2) /
              500;

            if (value >= maxChamferWidth) {
              let messageStr = 'Chamfer width must less than or equal to ' + maxChamferWidth + '\x22!';

              let message: Message = {
                title: 'Chamfer Width too Large',
                message: messageStr
              };
              if (this.warningAlerts) {
                this.utils.openDialog(message, 'error', () => {
                  this.setChamfer();
                });
              }
            }
          }

          let chamferHeight = value / math.tan((math.PI * this.settingsHolder.tool.taper) / 180);
          this.updateChamferHeight(chamferHeight);
          this.emitData('recommendations');
          if (this.isApp) {
            this.utils.apptentiveEngage('Chamfer Width (Numeric)');
          }
        }
      });

    this.Parameters.get('engagementAngle')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          this.engagementAngleChange(value);
          this.emitData('recommendations');
          if (this.isApp) {
            this.utils.apptentiveEngage('Engagement Angle (Numeric)');
          }
        }
      });

    this.Parameters.get('adocdecimal')
      .valueChanges //the same box is used for scallop width
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          if (this.warningAlerts) {
            this.cutDepth = value;
            if (this.cutDepth > 0) {
              if (
                this.settingsHolder.currenttoolpath &&
                this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('3d surfacing') > -1
              ) {
                // 3D Surfacing only
                if (this.cutDepth >= this.settingsHolder.tool.cutterDiameter / 2) {
                  let message: Message = {
                    title: 'ADOC too High!',
                    message: 'Axial cut depth must less than the radius of the ball nose endmill!'
                  };
                  this.utils.openDialog(message, 'error', () => {
                    this.setScallop(false); // already handled the stepover change
                    this.cutDepth = math.round(this.Parameters.get('adocdecimal').value, 3);
                    this.adocReset();
                  });
                }

                if (this.Parameters.get('scallopHeight').value > 0) {
                  let scallopHeight = this.Parameters.get('scallopHeight').value;
                  let scallopWidth = 0;

                  if (scallopHeight / 1000000 > value) {
                    scallopHeight = 1000000 * value;
                    scallopWidth =
                      math.floor(
                        10000 *
                          this.formulas.calculateScallopStepOver(this.settingsHolder.tool.cutterDiameter, scallopHeight)
                      ) / 10000;
                    this.updateScallopHeight(scallopHeight);
                    this.updateScallopWidth(scallopWidth);
                  }
                }
              } else if (value > 0) {
                if (this.Parameters.get('effectiveDiameter').value > 0) {
                  let maxChamferWidth =
                    math.floor(
                      (500 * (this.Parameters.get('effectiveDiameter').value - this.settingsHolder.tool.tip)) / 2
                    ) / 500;
                  if (this.Parameters.get('scallopWidth').value >= maxChamferWidth) {
                    let messageStr = 'Chamfer width must less than or equal to ' + maxChamferWidth + '!';

                    this.setChamfer(false);
                    let message: Message = {
                      title: 'Chamfer Width too Large!',
                      message: messageStr
                    };
                    this.utils.openDialog(message, 'error');
                  }
                }
                if (
                  this.settingsHolder.currenttoolpath &&
                  this.settingsHolder.currenttoolpath.operationName === 'Chamfering'
                ) {
                  let chamferHeight = value / math.tan((math.PI * this.settingsHolder.tool.taper) / 180);
                  this.updateScallopHeight(chamferHeight);
                }
              }

              if (this.settingsHolder.tool.lengthOfCut < this.cutDepth) {
                let message: Message = {
                  title: 'ADOC too High!',
                  message: 'Axial cut depth must not exceed endmill length of cut!'
                };
                this.utils.openDialog(message, 'error', () => {
                  this.adocReset();
                });

                this.cutDepth = this.settingsHolder.tool.lengthOfCut;
              }

              if (
                this.settingsHolder.currenttoolpath &&
                this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('3d surfacing') <= -1
              ) {
                this.updateADOC(this.cutDepth, false);
                let stepDown = (100 * value) / this.settingsHolder.tool.cutterDiameter;

                this.matchSliderToStepDown(stepDown);
                this.updateCutDepth(false);
              }
              this.setRDOC(undefined, undefined, true);
              if (
                this.settingsHolder.currenttoolpath &&
                this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('3d surfacing') > -1
              ) {
                this.updateCutDepth(false);
                this.emitData('recommendations');
              }
            } else {
              // user didn't enter a correct number so just make reset button available
              this.defaultSliderADOCDisabled = false;
            }
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('Axial Depth (Numeric)');
          }
        }
      });

    this.Parameters.get('rdocdecimal')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          if (value > 0) {
            this.cutWidth = this.Parameters.get('rdocdecimal').value;
            if (
              this.settingsHolder.currenttoolpath &&
              this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('full slotting') > -1
            ) {
              this.setSlotting(false);
            } else if (this.cutWidth >= this.settingsHolder.tool.cutterDiameter) {
              if (!this.warningMessageOpen) {
                this.slotMessage('RDOC');
              }
            } else if (this.cutWidth < this.settingsHolder.tool.cutterDiameter && this.cutWidth > 0) {
              if (
                this.settingsHolder.currenttoolpath &&
                this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('finishing') > -1
              ) {
                this.cutWidth = this.finMessage(CutWidthType.RADIAL_CUT_DEPTH, this.cutWidth);
              }
            }

            //set the sliders, need to calculate the stepOver
            this.updateCutWidth(); // this should recalculate the stepOver
            this.updateRDOC(this.cutWidth, false);
            setTimeout(() => {
              this.maxRDOCmessage();
            });
          } else {
            // user didn't enter a correct number so just make reset button available
            this.defaultSliderRDOCDisabled = false;
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('Radial Depth (Numeric)');
          }
        }
      });

    this.Parameters.get('stepOver')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          if (
            (this.settingsHolder.currenttoolpath &&
              this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('full slotting') > -1) ||
            (this.settingsHolder.currenttoolpath &&
              this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('helical plunge') > -1)
          ) {
            this.setSlotting(false);
          } else if (value >= 100) {
            if (!this.warningMessageOpen) {
              this.slotMessage('Stepover');
            }
          } else if (value < 100 && value > 0) {
            if (
              this.settingsHolder.currenttoolpath &&
              this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('finishing') > -1
            ) {
              value = (100 * this.finMessage(CutWidthType.STEPOVER, value)) / this.settingsHolder.tool.cutterDiameter;
            }
            this.updateRDOC((value * this.settingsHolder.tool.cutterDiameter) / 100);
            this.updateCutWidth(value);
          }
          this.updateEngagementAngle(
            this.conversionFormulas.convertRdocToTea(
              this.Parameters.get('rdocdecimal').value,
              this.settingsHolder.tool.cutterDiameter
            )
          );
          setTimeout(() => {
            if (
              this.currentPath !== 'Full Slotting' &&
              this.currentPath !== 'Chamfering' &&
              this.currentPath !== '3D Surfacing' &&
              this.currentPath !== 'Helical Plunge'
            ) {
              this.maxRDOCmessage();
            }
          });
          if (
            this.settingsHolder.currenttoolpath &&
            this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('3d surfacing') > -1
          ) {
            this.emitData('recommendations');
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('Radial Depth (Numeric)');
          }
        }
      });

    this.Parameters.get('stepDown')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          this.calculateStepDown();
          this.matchSliderToStepDown(value);

          if (
            this.settingsHolder.currenttoolpath &&
            this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('3d surfacing') > -1
          ) {
            this.emitData('recommendations');
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('Axial Depth (Numeric)');
          }
        }
      });

    this.Parameters.get('holeDepth')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          if (this.warningAlerts) {
            if (value > 0) {
              if (value > this.settingsHolder.tool.lengthOfCut) {
                let messageStr = 'Your hole depth is too deep for the selected endmill!';
                messageStr = messageStr + ' The depth must be less than the endmill length of cut.';

                let message: Message = {
                  title: 'Hole too Deep!',
                  message: messageStr
                };
                if (this.warningAlerts) {
                  this.utils.openDialog(message, 'error');
                }
              } else {
                this.vSliderValue = (this.trueMax * value) / this.settingsHolder.tool.lengthOfCut; // reverse of calculating the holedepth
                this.Parameters.get('stepDown').patchValue(this.vSliderValue, { emitEvent: false });
                this.emitData('recommendations');
              }
            }
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('Hole Depth (Numeric)');
          }
        }
      });

    this.Parameters.get('pathDiameter')
      .valueChanges //affects the pitch + hole
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          if (value > 0) {
            let cornerRadius = 0;
            if (this.settingsHolder.tool.cornerRadius > 0) {
              cornerRadius = this.settingsHolder.tool.cornerRadius;
            }

            if (value >= this.settingsHolder.tool.cutterDiameter - 2 * cornerRadius) {
              let messageStr = 'Your path diameter is too large for the selected endmill!';
              messageStr =
                messageStr +
                ' Keep your path diameter less than ' +
                (this.settingsHolder.tool.cutterDiameter - 2 * cornerRadius) +
                ' to avoid';
              messageStr = messageStr + ' leaving material in the center of the hole.';

              let message: Message = {
                title: 'Path Diameter too Large!',
                message: messageStr
              };
              if (this.warningAlerts) {
                this.utils.openDialog(message, 'error');
              }
            } else {
              this.updateHoleDiameter(value + this.settingsHolder.tool.cutterDiameter);
              let rampAngle = (math.PI * this.Parameters.get('rampAngle').value) / 180;
              this.updatePitch(this.formulas.calculateRamp2Pitch(rampAngle, value));
              this.emitData('recommendations');
            }
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('Path Diameter (Numeric)');
          }
        }
      });

    this.Parameters.get('holeDiameter')
      .valueChanges //affects the pitch + hole
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          if (value > 0) {
            let cornerRadius = 0;

            if (this.settingsHolder.tool.cornerRadius > 0) {
              cornerRadius = this.settingsHolder.tool.cornerRadius;
            }

            if (value >= 2 * (this.settingsHolder.tool.cutterDiameter - cornerRadius)) {
              let messageStr = 'Your hole diameter is too large for the selected endmill!<br />';
              messageStr =
                messageStr +
                'Keep your hole diameter less than ' +
                2 * (this.settingsHolder.tool.cutterDiameter - cornerRadius) +
                '\x22 to avoid<br />';
              messageStr = messageStr + 'leaving material in the center of the hole.';
              let message: Message = {
                title: 'Hole too Large!',
                message: messageStr
              };
              if (this.warningAlerts) {
                this.utils.openDialog(message, 'error');
              }
            } else if (value <= this.settingsHolder.tool.cutterDiameter) {
              let messageStr = 'Your hole diameter is too small for the selected endmill!<br />';
              messageStr = messageStr + 'You must enter a hole diameter that is<br />';
              messageStr = messageStr + 'greater than ' + this.settingsHolder.tool.cutterDiameter + '\x22.';

              let message: Message = {
                title: 'Hole too Small!',
                message: messageStr
              };
              if (this.warningAlerts) {
                this.utils.openDialog(message, 'error');
              }
            } else {
              this.updatePathDiameter(Number(value) - Number(this.settingsHolder.tool.cutterDiameter));
              let rampAngle = (math.PI * Number(this.Parameters.get('rampAngle').value)) / 180;

              let pathDiameter = this.Parameters.get('pathDiameter').value;
              this.updatePitch(this.formulas.calculateRamp2Pitch(rampAngle, pathDiameter));
              this.emitData('recommendations');
              // need to update slider to correct
            }
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('Hole Diameter (Numeric)');
          }
        }
      });

    this.Parameters.get('pitch')
      .valueChanges //affects the pitch + hole
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          if (value > 0) {
            let rampAngle =
              (180 * this.formulas.calculatePitch2Ramp(Number(value), this.Parameters.get('pathDiameter').value)) /
              math.PI;
            this.updateRampAngle(rampAngle);
            this.emSelection();
            this.emitData('recommendations');
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('Pitch (Numeric)');
          }
        }
      });

    this.Parameters.get('rampAngle')
      .valueChanges //affects the pitch + hole
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          if (value > 0) {
            let pitch = this.formulas.calculateRamp2Pitch(
              (math.PI * value) / 180,
              Number(this.Parameters.get('pathDiameter').value)
            );
            this.updatePitch(pitch);
            this.emSelection();
            this.emitData('recommendations');
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('Ramp Angle (Numeric)');
          }
        }
      });

    this.Parameters.get('scallopHeight')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          if (
            this.settingsHolder.currenttoolpath &&
            this.settingsHolder.currenttoolpath.operationName
              .toLowerCase()
              .toLowerCase()
              .indexOf('3d surfacing') > -1
          ) {
            if (this.Parameters.get('adocdecimal').value <= 0) {
              this.setADOC();
            }
            let axDepth = this.Parameters.get('adocdecimal').value;

            if (value > 0) {
              let scallopWidth =
                math.floor(
                  10000 * this.formulas.calculateScallopStepOver(this.settingsHolder.tool.cutterDiameter, value)
                ) / 10000;

              if (value > 1000000 * axDepth) {
                let messageStr = 'Scallop height must not exceed axial depth of cut!';
                value = 1000000 * axDepth;
                scallopWidth =
                  math.floor(
                    10000 * this.formulas.calculateScallopStepOver(this.settingsHolder.tool.cutterDiameter, value)
                  ) / 10000;

                if (this.warningAlerts) {
                  let message: Message = {
                    title: 'Scallop too High!',
                    message: messageStr
                  };
                  this.utils.openDialog(message, 'error');
                }
                this.updateScallopHeight(value); // only change it if this is true
              }

              this.updateScallopWidth(scallopWidth);
            }
          } else if (value > 0) {
            if (this.Parameters.get('effectiveDiameter').value > 0) {
              let maxChamferWidth =
                math.floor(
                  (500 * (this.Parameters.get('effectiveDiameter').value - this.settingsHolder.tool.tip)) / 2
                ) / 500;
              let maxChamferHeight =
                math.floor((500 * maxChamferWidth) / math.tan((math.PI * this.settingsHolder.tool.taper) / 180)) / 500;

              if (value >= maxChamferHeight) {
                let messageStr = 'Chamfer height must less than or equal to ' + maxChamferHeight + '!';

                this.setChamfer(false);
                if (this.warningAlerts) {
                  let message: Message = {
                    title: 'Chamfer Height too Large!',
                    message: messageStr
                  };
                  this.utils.openDialog(message, 'error');
                }
              }
            }

            let chamferWidth = value * math.tan((math.PI * this.settingsHolder.tool.taper) / 180);
            this.updateADOC(chamferWidth);
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('Scallop Height (Numeric)');
          }
        }
        this.emitData('recommendations');
      });

    this.Parameters.get('scallopWidth')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        let scallopWidth = value;
        //scallopHeightBox.Text = "";
        if (scallopWidth > 0) {
          if (
            this.settingsHolder.currenttoolpath &&
            this.settingsHolder.currenttoolpath.operationName === '3D Surfacing'
          ) {
            if (this.Parameters.get('adocdecimal').value <= 0) {
              this.setADOC();
            }

            let axDepth = this.Parameters.get('adocdecimal').value;

            if (scallopWidth > 0) {
              let scallopHeight = math.ceil(
                this.formulas.calculateScallopHeight(this.settingsHolder.tool.cutterDiameter, scallopWidth)
              );

              if (scallopHeight > 1000000 * axDepth) {
                scallopHeight = 1000000 * axDepth;
                scallopWidth =
                  math.floor(
                    10000 *
                      this.formulas.calculateScallopStepOver(this.settingsHolder.tool.cutterDiameter, scallopHeight)
                  ) / 10000;

                let messageStr = 'Scallop height must not exceed axial depth of cut!';

                if (this.warningAlerts) {
                  let message: Message = {
                    title: 'Scallop too High!',
                    message: messageStr
                  };
                  this.utils.openDialog(message, 'error');
                }
              }
              this.updateScallopHeight(scallopHeight);
            }
          } else if (scallopWidth > 0) {
            if (this.Parameters.get('effectiveDiameter').value > 0) {
              let maxChamferWidth =
                math.floor(
                  (500 * (Number(this.Parameters.get('effectiveDiameter').value) - this.settingsHolder.tool.tip)) / 2
                ) / 500;

              if (scallopWidth >= maxChamferWidth) {
                let messageStr = 'Chamfer width must less than or equal to ' + maxChamferWidth + '\x22!';

                this.setChamfer();
                if (this.warningAlerts) {
                  let message: Message = {
                    title: 'Chamfer Width too Large!',
                    message: messageStr
                  };
                  this.utils.openDialog(message, 'error');
                }
              }
            }

            let chamferHeight = scallopWidth / math.tan((math.PI * this.settingsHolder.tool.taper) / 180);
            this.updateADOC(chamferHeight);
          }
        }
        if (this.isApp) {
          this.utils.apptentiveEngage('Scallop Width (Numeric)');
        }
        this.emitData('recommendation');
      });

    this.Parameters.get('effectiveDiameter')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: number) => {
        value = Number(value);
        if (value) {
          if (value > 0) {
            if (value > this.settingsHolder.tool.cutterDiameter) {
              value = math.ceil(100 * (this.settingsHolder.tool.cutterDiameter + this.settingsHolder.tool.tip)) / 200;

              let messageStr = 'Effective cutting diameter must not exceed endmill diameter!';
              if (this.warningAlerts) {
                let message: Message = {
                  title: 'Effective Diameter too Large!',
                  message: messageStr
                };
                if (this.warningAlerts) {
                  this.utils.openDialog(message, 'error');
                }
              }
              this.updateEffectiveDiameter(value);
            } else if (value <= this.settingsHolder.tool.tip) {
              let messageStr = 'Effective cutting diameter must be greater than tip diameter!';
              value = math.ceil(100 * (this.settingsHolder.tool.cutterDiameter + this.settingsHolder.tool.tip)) / 200;
              if (this.warningAlerts) {
                let message: Message = {
                  title: 'Effective Diameter too Small!',
                  message: messageStr
                };
                if (this.warningAlerts) {
                  this.utils.openDialog(message, 'error');
                }
              }
              this.updateEffectiveDiameter(value);
            }

            this.setChamfer();
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('Effective Diameter (Numeric)');
          }
        }
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.sliderRdocDisabled = true;
      this.sliderDisabled = true;
      this.rows.length = 0;

      this.subscription = this.commonService.notifyObservable$.subscribe(res => {
        if (res.hasOwnProperty('option') && res.option === 'logout') {
          this.subscription.unsubscribe();
        }
        if (res.hasOwnProperty('option') && res.option === 'FeedInsideSlotChange') {
          this.settingsHolder.recommendationFields = 2;
          this.settingsHolder.recommendationForm = res.value;
        }
        if (
          res.hasOwnProperty('option') &&
          (res.option === 'parameters' ||
            res.option === 'resetMaterial' ||
            res.option === 'trochoidalSlotWidthChange' ||
            res.option === 'insideCornerChange' ||
            res.option === 'switchedFromChamferingTool')
        ) {
          if (res.option === 'trochoidalSlotWidthChange') {
            this.trochoidalSlotWidthChange = true;
          }

          let insideCornerChange = !!res.insideCornerValueChange || res.option === 'insideCornerChange';

          if (res.option === 'resetMaterial' || res.option === 'switchedFromChamferingTool') {
            this.resetParameters();
          }
          if (
            (!res.workHoldingChange && !res.maxRPMIPMChange) ||
            this.trochoidalSlotWidthChange ||
            insideCornerChange
          ) {
            // changing holder SHOULD not change the Parameters section, would change recommendation calculations but not Parameters

            this.settingsHolder = res.value;
            this.emit = res.emit;
            this.origin = res.origin;
            this.warningAlerts = res.warningAlerts;

            // got notified!
            if (this.settingsHolder.tool) {
              this.toolSwap();
            }

            //before anything happens, let check if the material allows this tool
            let materialIdsList = this.settingsHolder.tool ? this.settingsHolder.tool.materialIds : undefined;
            let theMaterial = this.settingsHolder.material ? this.settingsHolder.material : undefined;
            let theHolder = this.settingsHolder.machine ? this.settingsHolder.machine.holder : undefined;
            if (materialIdsList && theMaterial) {
              // Check if the selected material works with the selected tool.
              // If not it will open a warning modal asking user to change material or tool
              if (!!materialIdsList.find(id => id === theMaterial.id)) {
                let chosenCondition = false;
                if (this.settingsHolder.material) {
                  if ('chosenCondition' in this.settingsHolder.material) {
                    if (this.settingsHolder.material['chosenCondition']) {
                      chosenCondition = true;
                    }
                  }
                }

                if (
                  (this.settingsHolder.hardness &&
                    this.settingsHolder.tool &&
                    this.settingsHolder.currenttoolpath &&
                    this.settingsHolder.currenttoolpath.operationName &&
                    (!this.settingsHolder.hasStrategyOption ||
                      (this.settingsHolder.currentStrategy && this.settingsHolder.currentStrategy.operationName)) &&
                    chosenCondition &&
                    theHolder) ||
                  this.trochoidalSlotWidthChange
                ) {
                  let holderChange = false;

                  if (theHolder !== this.holder && this.holder) {
                    // basically holder should NOT trigger recalc to parameters
                    this.holder = theHolder;
                    holderChange = true;
                  }

                  if (!this.holder) {
                    // setting default
                    this.holder = theHolder;
                  }

                  if (!holderChange || this.trochoidalSlotWidthChange || insideCornerChange) {
                    this.parameterTypes = this.settingsHolder.parametersFields;
                    setTimeout(() => {
                      if (!this.settingsHolder.tool || !this.settingsHolder.currenttoolpath.operationName) {
                        return;
                      }

                      //needed to allow time for the templates to switch before plopping the numbers in
                      // want to make sure there is a holder before doing anything BUT Parameters don't really need a holder though, and changing holder SHOULD not affect Parameters

                      const maxStepDown = this.settingsHolder.tool.cutterDiameter === 0 ? 0 : math.round(
                        (100 * this.settingsHolder.tool.lengthOfCut) / this.settingsHolder.tool.cutterDiameter,
                        4
                      );

                      this.sliderRdocDisabled = false;
                      this.adocLockDisabled = false;
                      this.rdocLockDisabled = false;

                      this.knobDisabler = false;
                      if (
                        this.settingsHolder.currenttoolpath.operationName !== 'Trochoidal Slotting' &&
                        !insideCornerChange
                      ) {
                        this.sliderDisabled = false;
                        this.rdocLocked = false;
                        this.adocLocked = false;
                        if (!!!this.settingsHolder.parameters) {
                          this.emSelection(res.emit);
                        } else {
                          this.emSelection(res.emit, this.settingsHolder.parameters.stepOver);
                        }
                      }

                      this.rows.length = math.round(maxStepDown, 0);

                      this.overlayDivideFactor = maxStepDown / 100; // dividing by a 100 cause the overlay is 100%

                      this.trueMax = (this.rows.length / this.overlayDivideFactor) * 10; //80

                      // This value is unused. Is this still required?
                      this.adocTicks = this.rows.length;
                      if (this.settingsHolder.tool.lengthOfCut >= 0.5) {
                        this.adocTicks = math.floor(8 * this.adocMax);
                      }
                      this.offset = 100 - this.trueMax < 0 ? (100 - this.trueMax) * -1 : 100 - this.trueMax; // 20 is the offset

                      this.sliderMax =
                        this.currentPath !== 'Helical Plunge' ? this.rows.length * 10 : this.rows.length * 100;

                      //by this time the overlay SHOULD be well calculated
                      this.vSliderValue =
                        (Number(this.Parameters.get('stepDown').value) / this.overlayDivideFactor) *
                        0.01 *
                        this.sliderMax;
                      if (
                        !!this.settingsHolder.currenttoolpath &&
                        !!this.settingsHolder.currenttoolpath.operationName &&
                        this.settingsHolder.currenttoolpath.operationName !== 'Trochoidal Slotting' &&
                        this.settingsHolder.currenttoolpath.operationName !== 'Chamfering' &&
                        this.settingsHolder.currenttoolpath.operationName !== '3D Surfacing'
                      ) {
                        this.onVerticalSliderChange({ value: this.vSliderValue }, false, false, false, false);
                      }
                      this.currentPath = this.settingsHolder.currenttoolpath.operationName;

                      if (this.settingsHolder.currenttoolpath.operationName === 'Helical Plunge') {
                        this.sliderRdocDisabled = true;
                        this.rdocLockDisabled = true;
                        const maxStepDown = math.round(
                          (100 * this.settingsHolder.tool.lengthOfCut) / this.settingsHolder.tool.cutterDiameter,
                          4
                        );
                        this.rows.length = math.round(maxStepDown, 0);
                        this.adocTicks = this.rows.length;
                        if (this.settingsHolder.tool.lengthOfCut >= 0.5) {
                          this.adocTicks = math.floor(8 * this.adocMax);
                        }

                        this.trueMax = this.rows.length * 10;
                        this.offset = 100 - this.trueMax < 0 ? (100 - this.trueMax) * -1 : 100 - this.trueMax; // 20 is the offset

                        this.emSelection(
                          res.emit,
                          undefined,
                          false,
                          Number(this.Parameters.get('engagementAngle').value)
                        );

                        this.vSliderValue =
                          (Number(this.Parameters.get('holeDepth').value) / this.settingsHolder.tool.lengthOfCut) *
                          this.trueMax;

                        this.onVerticalSliderChange({ value: this.vSliderValue }, false, false);
                        this.Parameters.get('stepDown').patchValue(this.vSliderValue, { emitEvent: true });
                      } else if (this.currentPath === 'Trochoidal Slotting') {
                        if (this.trochoidalSlotWidthChange) {
                          this.setRDOC();
                          let data = this.settingsHolder;
                          data.parameters = {
                            toolPath: this.settingsHolder.currenttoolpath,
                            cutterDiameter: this.settingsHolder.tool.cutterDiameter,
                            stickOut: this.Parameters.get('stickOut').value,
                            stickoutPercentage: this.Parameters.get('stickoutPercentage').value,
                            pitch: this.Parameters.get('pitch').value,
                            rampAngle: this.Parameters.get('rampAngle').value,
                            holeDiameter: this.Parameters.get('holeDiameter').value,
                            pathDiameter: this.Parameters.get('pathDiameter').value,
                            holeDepth: this.Parameters.get('holeDepth').value,
                            effectiveDiameter: this.Parameters.get('effectiveDiameter').value,
                            chamferHeight: this.Parameters.get('chamferHeight').value,
                            chamferWidth: this.Parameters.get('chamferWidth').value,
                            scallopHeight: this.Parameters.get('scallopHeight').value,
                            scallopWidth: this.Parameters.get('scallopWidth').value,
                            cutWidth: this.cutWidth,
                            cutDepth: this.cutDepth,
                            stepDown: this.Parameters.get('stepDown').value,
                            stepOver: this.Parameters.get('stepOver').value,
                            adocdecimal: this.Parameters.get('adocdecimal').value,
                            rdocdecimal: this.Parameters.get('rdocdecimal').value,
                            engagementAngle: this.Parameters.get('engagementAngle').value,
                            vSliderValue: this.vSliderValue
                          };
                          this.commonService.notifyOther({
                            option: 'trochoidalSlotWidthChangeBackToRecommendations',
                            value: data,
                            emit: false
                          });
                          this.trochoidalSlotWidthChange = false;
                        } else {
                          this.cutDepth = this.formulas.calculateCutDepth(
                            this.settingsHolder.tool,
                            this.settingsHolder.hardness.hra,
                            this.currentPath
                          );

                          let roundFactor = this.formulas.emRoundFactor(this.settingsHolder.tool.cutterDiameter);

                          let wallRadius = (this.settingsHolder.tool.cutterDiameter * 1.5) / 2;
                          let maxEngageAng = this.formulas.calculateMaxEngageAngle(
                            this.settingsHolder.tool,
                            this.cutDepth,
                            this.settingsHolder.material,
                            this.settingsHolder.hardness.hra
                          );
                          this.maxRDOC =
                            roundFactor *
                            math.floor(
                              this.formulas.calculateMaxFilletRdoc(
                                this.settingsHolder.tool.cutterDiameter,
                                wallRadius,
                                maxEngageAng
                              ) / roundFactor
                            );

                          this.updateRDOC(this.maxRDOC);
                          this.updateEngagementAngle(
                            this.conversionFormulas.convertRdocToTea(
                              this.maxRDOC,
                              this.settingsHolder.tool.cutterDiameter,
                              wallRadius
                            )
                          );

                          let stepOver =
                            roundFactor *
                            math.floor((100 * (this.maxRDOC / this.settingsHolder.tool.cutterDiameter)) / roundFactor);
                          this.updateStepOver(stepOver);

                          this.emSelection(
                            res.emit,
                            stepOver,
                            false,
                            Number(this.Parameters.get('engagementAngle').value)
                          );

                          this.sliderMax = this.rows.length * 10 * this.overlayDivideFactor;
                          this.vSliderValue =
                            (Number(this.Parameters.get('stepDown').value) / this.overlayDivideFactor) *
                            0.01 *
                            this.sliderMax;

                          this.maxRDOCmessage();
                          this.sliderDisabled = false;
                          this.sliderRdocDisabled = false;
                          this.adocLocked = false;
                          this.rdocLocked = false;
                        }
                      } else if (this.settingsHolder.currenttoolpath.operationName === 'Full Slotting') {
                        this.emSelection(
                          res.emit,
                          this.Parameters.get('stepDown').value,
                          false,
                          Number(this.Parameters.get('engagementAngle').value)
                        );
                        this.sliderRdocDisabled = true;
                        this.rdocLockDisabled = true;
                        this.rdocLocked = true;
                      }
                      if (this.warningAlerts && !this.trochoidalSlotWidthChange && !insideCornerChange) {
                        if (
                          this.settingsHolder.currenttoolpath.operationName !== 'Chamfer' &&
                          this.settingsHolder.currenttoolpath.operationName !== '3D Surfacing'
                        ) {
                          let cutDepth = this.formulas.calculateCutDepth(
                            this.settingsHolder.tool,
                            this.settingsHolder.hardness.hra,
                            this.settingsHolder.currenttoolpath.operationName
                          ); //default adoc
                          this.adoc = math.round(cutDepth, 3);
                        } else {
                          let cutDepth = this.formulas.calculateCutDepth(
                            this.settingsHolder.tool,
                            this.settingsHolder.hardness.hra,
                            this.settingsHolder.currenttoolpath.operationName
                          );
                          let scallopHeight = 1000000 * cutDepth;
                          let scallopWidth =
                            math.floor(
                              10000 *
                                this.formulas.calculateScallopStepOver(
                                  this.settingsHolder.tool.cutterDiameter,
                                  scallopHeight
                                )
                            ) / 10000;
                          this.adoc = math.round(scallopWidth, 3);
                        }

                        this.defaultEngagementAngle = Number(this.Parameters.get('engagementAngle').value);
                        this.rdoc = Number(this.Parameters.get('rdocdecimal').value);
                        setTimeout(() => {
                          // needed time for the slider to set first
                          this.defaultSliderADOCDisabled = true;
                          this.defaultSliderRDOCDisabled = true;

                          this.defaultSliderADOC = this.adocSlider['value'];
                          this.defaultSliderRDOC = this.rdocSlider['value'];

                          // let notify JUST recommendation, there too much going on in tools that tools is not accurately reporting to Recommendations
                          // atleast for initial

                          let data = this.settingsHolder;
                          data.parameters = {
                            toolPath: this.settingsHolder.currenttoolpath,
                            cutterDiameter: this.settingsHolder.tool.cutterDiameter,
                            stickOut: this.Parameters.get('stickOut').value,
                            stickoutPercentage: this.Parameters.get('stickoutPercentage').value,
                            pitch: this.Parameters.get('pitch').value,
                            rampAngle: this.Parameters.get('rampAngle').value,
                            holeDiameter: this.Parameters.get('holeDiameter').value,
                            pathDiameter: this.Parameters.get('pathDiameter').value,
                            holeDepth: this.Parameters.get('holeDepth').value,
                            effectiveDiameter: this.Parameters.get('effectiveDiameter').value,
                            chamferHeight: this.Parameters.get('chamferHeight').value,
                            chamferWidth: this.Parameters.get('chamferWidth').value,
                            scallopHeight: this.Parameters.get('scallopHeight').value,
                            scallopWidth: this.Parameters.get('scallopWidth').value,
                            cutWidth: this.cutWidth,
                            cutDepth: this.cutDepth,
                            stepDown: this.Parameters.get('stepDown').value,
                            stepOver: this.Parameters.get('stepOver').value,
                            adocdecimal: this.Parameters.get('adocdecimal').value,
                            rdocdecimal: this.Parameters.get('rdocdecimal').value,
                            engagementAngle: this.Parameters.get('engagementAngle').value,
                            vSliderValue: this.vSliderValue
                          };

                          this.commonService.notifyOther({
                            option: 'parameterReportingToRecoomendation',
                            value: data,
                            origin: this.origin
                          }); // resetting all, all will listen for a "RESET"
                        });
                        // just want to warn the user
                        if (
                          this.settingsHolder.currenttoolpath.operationName === 'High Efficiency Milling' ||
                          this.settingsHolder.currenttoolpath.operationName === 'Trochoidal Slotting'
                        ) {
                          if (!this.invalidEndmillModal) {
                            this.invalidEndmillModal = true;
                            let message: Message = {
                              title: 'Caution!',
                              message:
                                '<h5>Use this tool path selection only if you are employing tool path strategies with a high performance CAM system that intelligently manages tool load in corners.</h5>'
                            };
                            this.utils.openDialog(
                              message,
                              'alert',
                              () => {
                                this.invalidEndmillModal = false;
                              },
                              () => {
                                this.invalidEndmillModal = false;
                              }
                            );
                          }
                        }
                      }
                    });
                  }
                }
                // end check for toolpath
                this.setShowMapModeVersion();
              } else {
                // if filtering all happened, this should not happen, but this message serves a fail safe, even in the old app
                if (!this.invalidEndmillModal) {
                  this.invalidEndmillModal = true;
                  let message: Message = {
                    title: 'Invalid',
                    message:
                      'The endmill you selected ' +
                      this.settingsHolder.tool.itemId +
                      ' (' +
                      this.settingsHolder.tool.description +
                      ') is not suited for the selected material.<br />Would you like to change the material?'
                  };
                  this.utils.openDialog(
                    message,
                    'confirm',
                    () => {
                      // ok
                      this.invalidEndmillModal = false;
                      this.resetMaterial.emit();
                    },
                    () => {
                      // cancel, reset the tool, cause it ain't gonna work and it will crash parameters section
                      this.invalidEndmillModal = false;
                      this.resetTool.emit();
                    }
                  );
                }
              }
            }
          }
        } else if ((res.hasOwnProperty('option') && res.option === 'reset') || res.option === 'resetTool') {
          this.resetParameters();
        } else if (res.hasOwnProperty('option') && res.option === 'clearToolPath') {
          this.mapMode = 1;
          this.resetParameters();
        } else if (res.hasOwnProperty('option') && res.option === 'mapModeChanged') {
          this.mapMode = res.value.mapMode;
          if (this.mapMode === 2) {
            this.operationToolImage = !!res.value.operationImageAssetForParameterSection
              ? res.value.operationImageAssetForParameterSection
              : this.imageConstants.unavailableOperationImage;
          }
        }
      });

      this.columns.length = 10;

      this.onResize();
    });
  }

  private setShowMapModeVersion = () => {
    if (
      this.mapMode === 2 &&
      this.settingsHolder.currenttoolpath &&
      this.settingsHolder.currenttoolpath.operationName &&
      (!this.settingsHolder.hasStrategyOption ||
        (this.settingsHolder.currentStrategy && this.settingsHolder.currentStrategy.operationName)) &&
      this.settingsHolder.machine &&
      this.settingsHolder.machine.holderAdjustment &&
      this.settingsHolder.machine.spindleAdjustment
    ) {
      this.showMapModeTwo = true;
    } else {
      this.showMapModeTwo = false;
    }
  };

  private resetParameters = () => {
    this.settingsHolder.mapMode = 1;
    this.Parameters.reset(
      {
        engagementAngle: 0,
        stepDown: 0,
        stepOver: 0,
        adocdecimal: 0,
        rdocdecimal: 0,
        stickOut: 0,
        stickoutPercentage: 0,
        pitch: 0,
        rampAngle: 0,
        holeDiameter: 0,
        pathDiameter: 0,
        holeDepth: 0,
        effectiveDiameter: 0,
        chamferHeight: 0,
        chamferWidth: 0,
        scallopHeight: 0
      },
      { emitEvent: true }
    );
    this.parameters = new Parameters_();
    this.settingsHolder = new ToolContainer();
    this.vSliderValue = 0;
    this.warningAlerts = true;
    this.aggressiveFlag = false;
    this.toolImage = this.imageConstants.defaultTool;
    this.mapMode = 1;
    this.operationToolImage = '';

    setTimeout(() => {
      // let parameters reset everything before disabling all of the sliders/knobs
      this.knobDisabler = true;
      this.sliderDisabled = true;
      this.sliderRdocDisabled = true;
      this.defaultSliderADOCDisabled = true;
      this.defaultSliderRDOCDisabled = true;
      this.origin = undefined;
      this.currentPath = '';
      this.tool = new Cutter_();
      this.parameterTypes = 0;
      this.rows = [];
      this.columns.length = 10;
      this.current = this.constants.getMillBit(0);
      this.adocSize = 0;
      this.horizontalSliderHolderWidth = 0;
      this.horizontalSliderHolderHeight = 0;
      this.cutWidth = 0;
      this.cutDepth = 0;
      this.offset = 0;
      this.adocMax = 32;
      this.stepOver = 0;
      this.trueMax = 0;
      this.maxRDOC = 100;
      this.adoc = undefined;
      this.rdoc = undefined;
      this.defaultEngagementAngle = undefined;

      this.defaultSliderRDOC = undefined;
      this.defaultSliderADOC = undefined;
      this.adocTicks = 32;
      this.overlayDivideFactor = 2;
      this.sliderMax = 300;
      this.warningMessageOpen = false;

      this.holder = undefined;
      this.trochoidalSlotWidthChange = false;
      this.adocLocked = false;
      this.rdocLocked = false;
      this.adocLockDisabled = true;
      this.rdocLockDisabled = true;

      this.setShowMapModeVersion();

      this.emitData('recommendations');
    });
  };

  // formula specific functions
  private setScallop = (notify: boolean = true) => {
    let roundFactor = math.round(math.log10(80 * this.settingsHolder.tool.cutterDiameter), 0) / 400;
    let stepOver =
      roundFactor *
      math.floor(this.formulas.calculateScallopStepOver(this.settingsHolder.tool.cutterDiameter, 125) / roundFactor);
    let scallopHeight = math.ceil(
      this.formulas.calculateScallopHeight(this.settingsHolder.tool.cutterDiameter, stepOver)
    );

    if (this.settingsHolder.currenttoolpath && this.settingsHolder.currenttoolpath.operationName === '3D Surfacing') {
      this.updateScallopWidth(stepOver);
    } else {
      this.updateStepOver(stepOver);
    }
    this.updateScallopHeight(scallopHeight);
  };

  private setSlotting = (notify: boolean = true) => {
    if (this.settingsHolder.tool.cutterDiameter > 0) {
      this.updateRDOC(this.settingsHolder.tool.cutterDiameter);
    }
    this.updateStepOver(100);
    this.updateEngagementAngle(180);

    this.setADOC(undefined, notify);
  };

  private setADOC = (setAdoc: boolean = true, notify: boolean = true) => {
    if (setAdoc) {
      const { hardness } = this.settingsHolder;
      const hra = hardness.userHra ? hardness.userHra : hardness.hra;
      this.cutDepth = 0;
      this.cutDepth = this.formulas.calculateCutDepth(
        this.settingsHolder.tool,
        hra,
        this.settingsHolder.currenttoolpath ? this.settingsHolder.currenttoolpath.operationName : ''
      );
      this.updateADOC(this.cutDepth);
      this.updateCutDepth();
    }
  };

  private setHoleDiameter = (notify: boolean = true) => {
    let roundFactor = math.round(math.log10(150 * this.settingsHolder.tool.cutterDiameter), 0) / 200;
    let corRad = this.settingsHolder.tool.cornerRadius > 0 ? this.settingsHolder.tool.cornerRadius : 0;
    this.updateHoleDiameter(
      roundFactor * math.floor((1.6 * (this.settingsHolder.tool.cutterDiameter - corRad)) / roundFactor)
    );
    this.updatePathDiameter(this.Parameters.get('holeDiameter').value - this.settingsHolder.tool.cutterDiameter);

    let rampAng = (math.PI * this.Parameters.get('rampAngle').value) / 180;

    this.updatePitch(this.formulas.calculateRamp2Pitch(rampAng, this.Parameters.get('pathDiameter').value));
  };

  private setHoleDepth = (notify: boolean = true) => {
    let roundFactor = math.round(math.log10(80 * this.settingsHolder.tool.cutterDiameter), 0) / 8;

    let holeDepth = roundFactor * math.floor((this.settingsHolder.tool.lengthOfCut - 0.005) / roundFactor);

    if (this.settingsHolder.tool.rNeck) {
      holeDepth = this.settingsHolder.tool.lengthOfCut;
    }

    this.updateHoleDepthField(holeDepth);

    this.updateHoleDepth(notify);
  };

  private setHolePitch = (notify: boolean = true) => {
    //defaults?
    let rampAng =
      math.sqrt(
        this.formulas.calculateMaterialSurfaceFeetPerMinute(
          this.settingsHolder.material,
          this.settingsHolder.hardness.hra
        ) / this.formulas.calculateMaterialStretch(this.settingsHolder.material)
      ) / 380;

    let pitch = 0;
    if (isNaN(rampAng) && this.Parameters.get('pitch').value > 0) {
      pitch = this.Parameters.get('pitch').value;
      rampAng = this.formulas.calculatePitch2Ramp(
        this.Parameters.get('pitch').value,
        this.Parameters.get('pathDiameter').value
      );
      this.updateRampAngle((180 * rampAng) / math.PI);
      this.Parameters.get('rampAngle').patchValue((180 * rampAng) / math.PI, { emitEvent: false });
    } else if (!this.Parameters.get('rampAngle').value) {
      this.updateRampAngle((180 * rampAng) / math.PI);
      pitch = this.formulas.calculateRamp2Pitch(rampAng, this.Parameters.get('pathDiameter').value);
    }

    if (!this.Parameters.get('pathDiameter').value) {
      pitch = pitch < 0.01 ? math.floor(1000 * pitch) / 1000 : math.floor(200 * pitch) / 200;
      rampAng = this.formulas.calculatePitch2Ramp(pitch, this.Parameters.get('pathDiameter').value);

      this.updatePitch(pitch);
      this.updateRampAngle((180 * rampAng) / math.PI);
    }
  };

  private setChamfer = (notify: boolean = true) => {
    this.updateChamferWidth(this.formulas.calculateFinishWallStock(this.Parameters.get('effectiveDiameter').value));
    this.updateChamferHeight(
      this.Parameters.get('chamferWidth').value / math.tan((math.PI * this.settingsHolder.tool.taper) / 180)
    );
    if (notify) {
      this.emitData();
    }
  };

  private setChamferDiameter = (notify: boolean = true) => {
    this.updateEffectiveDiameter(
      math.ceil(100 * (this.settingsHolder.tool.cutterDiameter + this.settingsHolder.tool.tip)) / 200
    );
    this.setChamfer(notify);
  };

  private setProtrude = () => {
    let roundFactor =
      math.pow(2, math.round(math.log(4.5 * math.pow(this.settingsHolder.tool.cutterDiameter, 2.0 / 3.0), 2))) / 16;
    let stickOut =
      roundFactor *
      math.ceil((this.settingsHolder.tool.fluteWash + this.settingsHolder.tool.lengthOfCut) / roundFactor);

    if (this.settingsHolder.tool.rNeck) {
      stickOut = this.settingsHolder.tool.overallReach;
    } else if (this.settingsHolder.tool.end.indexOf('Chamfer') > -1) {
      stickOut = this.settingsHolder.tool.overallLength / 2;

      if (3 * this.settingsHolder.tool.cutterDiameter < stickOut) {
        stickOut = 3 * this.settingsHolder.tool.cutterDiameter;
      }
    }

    this.updateStickOut(stickOut);
    this.updateStickoutPercentage((100 * stickOut) / this.settingsHolder.tool.cutterDiameter);
  };

  private setProfile = (updateCutWidth: boolean = true, notify: boolean = true, setRdoc: boolean = true) => {
    this.setADOC(true, notify);

    if (this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('3d surfacing') > -1) {
      this.setScallop(notify);
    } else {
      if (setRdoc) {
        this.setRDOC(notify, updateCutWidth);
      }
    }
  };

  private setRDOC = (notify: boolean = false, updateCutWidth: boolean = true, updateDefaults: boolean = false) => {
    let roundFactor = this.formulas.emRoundFactor(this.settingsHolder.tool.cutterDiameter);
    _.extend(this.settingsHolder.material, this.settingsHolder.hardness);

    this.cutWidth =
      roundFactor *
      math.round(
        this.formulas.setCutWidth(
          this.settingsHolder.tool,
          this.Parameters.get('adocdecimal').value,
          this.settingsHolder.material,
          this.settingsHolder.currenttoolpath ? this.settingsHolder.currenttoolpath.operationName : '',
          this.settingsHolder.hardness.hra
        ) / roundFactor
      );

    const form = this.settingsHolder.recommendationForm;
    const toolPath = this.settingsHolder.currenttoolpath.operationName.toLowerCase();

    if (form) {
      // if the recommendations is changed

      let insideCornerRadiusWall;
      if (this.settingsHolder.recommendationFields === 1) {
        insideCornerRadiusWall = form.get('type1').get('insideCornerRadiusOfWall').value;
      } else if (this.settingsHolder.recommendationFields === 2) {
        insideCornerRadiusWall = form.get('type2').get('trochoidalSlotWidth').value;
      }

      if (insideCornerRadiusWall) {
        if (
          ((toolPath.includes('high efficiency milling') || toolPath.includes('finishing')) &&
            form.get('type1').get('insideCornerType').value) ||
          toolPath.includes('trochoidal slotting')
        ) {
          let wallRadius = toolPath.includes('trochoidal slotting')
            ? insideCornerRadiusWall / 2
            : insideCornerRadiusWall;

          let maxEngageAng = this.formulas.calculateMaxEngageAngle(
            this.settingsHolder.tool,
            this.Parameters.get('adocdecimal').value,
            this.settingsHolder.material,
            this.settingsHolder.hardness.hra
          );
          this.maxRDOC =
            roundFactor *
            math.floor(
              this.formulas.calculateMaxFilletRdoc(this.settingsHolder.tool.cutterDiameter, wallRadius, maxEngageAng) /
                roundFactor
            );
          let minFillet =
            math.ceil(
              200 *
                this.formulas.calculateMinFilletRad(
                  this.settingsHolder.tool.cutterDiameter,
                  this.cutWidth,
                  maxEngageAng
                )
            ) / 200;

          if (this.settingsHolder.machine) {
            if (_.trim(this.settingsHolder.machine.holder).length > 0) {
              if (this.cutWidth > this.maxRDOC) {
                if (this.maxRDOC > 0) {
                  this.cutWidth = this.maxRDOC; // overrides locked RDOC
                } else {
                  this.handleInvalidFillet(toolPath, minFillet);
                }
              }
            }
          }
        }
      }
    }

    if (toolPath.includes('full slotting') || toolPath.includes('helical plunge')) {
      this.cutWidth = this.settingsHolder.tool.cutterDiameter; // overrides locked RDOC
    }

    this.updateRDOC(this.cutWidth, notify, updateDefaults);

    if (updateCutWidth) {
      this.updateCutWidth(undefined, undefined, true, updateDefaults);
    }
  };

  private handleInvalidFillet = (toolPath: string, minFillet: number) => {
    const form = this.settingsHolder.recommendationForm;
    if (toolPath.includes('trochoidal slotting')) {
      const input = form.get('type2').get('trochoidalSlotWidth');
      this.utils.openDialog(
        {
          title: 'Slot Width too Small!',
          message: `A slot width of ${input.value} is too small for this tool to clear chips!`
        },
        'error'
      );
      input.patchValue(math.round(2 * minFillet, 2), { emitEvent: false });
    } else {
      const input = form.get('type1').get('insideCornerRadiusOfWall');
      this.utils.openDialog(
        {
          title: 'Part Fillet too Small!',
          message: `A radius of ${input.value} is too small for this tool to clear chips!`
        },
        'error'
      );
      this.commonService.notifyOther({ option: 'resetInsideCornerRadiusOfWall', value: true });
    }
  };

  private updateCutWidth = (
    stepOver?: number,
    engagementAngle?: number,
    notify: boolean = true,
    updateDefaults = false
  ) => {
    if (this.Parameters.get('rdocdecimal').value > 0) {
      if (!stepOver && this.currentPath !== '3D Surfacing') {
        this.updateStepOver(100 * (this.cutWidth / this.settingsHolder.tool.cutterDiameter), updateDefaults);
      }
      if (!this.rdocLocked) {
        this.updateTeaBasedOnRdoc(!!stepOver, !!engagementAngle);
      }
      if (notify) {
        this.emitData();
      }
    }
  };

  private updateTeaBasedOnRdoc = (stepOver: boolean, engagementAngle: boolean) => {
    if (!stepOver) {
      if (!engagementAngle || this.origin === 'recommendations') {
        //ONLY RECALC if updateCutWidth was triggered by other field other than engagement Angle
        let engageAng: number;
        if (
          this.settingsHolder.recommendationFields === 2 ||
          this.settingsHolder.currenttoolpath.operationName === 'Trochoidal Slotting'
        ) {
          let partRad = 0;

          if (this.settingsHolder.recommendationFields && this.settingsHolder.recommendationForm) {
            partRad = this.settingsHolder.recommendationForm.get('type2').get('trochoidalSlotWidth').value / 2;
          }

          engageAng = this.conversionFormulas.convertRdocToTea(
            this.cutWidth,
            this.settingsHolder.tool.cutterDiameter,
            partRad
          );
        } else {
          engageAng = this.conversionFormulas.convertRdocToTea(this.cutWidth, this.settingsHolder.tool.cutterDiameter);
        }

        if (engageAng !== this.defaultEngagementAngle) {
          this.updateEngagementAngle(engageAng);
        }
      }
    } else if (!engagementAngle) {
      let engageAng: number;
      if (
        this.settingsHolder.recommendationForm &&
        this.settingsHolder.recommendationForm.get('type1').get('insideCornerType').value !== 'RDOC Inside Corner' &&
        this.settingsHolder.parameters
      ) {
        let partRad = 0;

        if (this.settingsHolder.recommendationFields === 1) {
          partRad = this.settingsHolder.recommendationForm.get('type1').get('insideCornerRadiusOfWall').value;
        } else if (this.settingsHolder.recommendationFields === 2) {
          partRad = this.settingsHolder.recommendationForm.get('type2').get('trochoidalSlotWidth').value / 2;
        }

        engageAng = this.conversionFormulas.convertRdocToTea(
          this.settingsHolder.parameters.rdocdecimal,
          this.settingsHolder.tool.cutterDiameter,
          partRad
        );
      } else {
        engageAng = this.conversionFormulas.convertRdocToTea(this.cutWidth, this.settingsHolder.tool.cutterDiameter);
      }
      if (engageAng !== this.defaultEngagementAngle) {
        this.updateEngagementAngle(engageAng);
      }
    }
  };

  private updateCutDepth = (emit: boolean = true) => {
    this.updateStepDown((100 * this.cutDepth) / this.settingsHolder.tool.cutterDiameter, emit);
  };

  private emSelection = (
    notify: boolean = true,
    stepOver?: number,
    setRdoc: boolean = true,
    engagementAngle?: number
  ) => {
    let toolPath = this.settingsHolder.currenttoolpath.operationName;
    // need to have a tool first
    if (this.settingsHolder.tool) {
      if (this.settingsHolder.tool.lengthOfCut === 0) {
        this.adocMax = 32;
      } else {
        this.adocMax = 32 * this.settingsHolder.tool.lengthOfCut;
      }

      if (this.settingsHolder.tool.end.indexOf('Chamfer') > -1) {
        this.filterOperationPaths.emit({ end: 'Chamfering' });
      } else {
        if (
          this.settingsHolder.tool.end.indexOf('Ball-Nosed') > -1 &&
          this.settingsHolder.tool.description.indexOf('BN') > -1
        ) {
          this.setScallop(false); // set the stickout
          this.filterOperationPaths.emit({ end: '3D Surfacing' });
        } else {
          this.filterOperationPaths.emit({ end: 'reset' });
        }
      }

      if (this.settingsHolder.tool.materials && this.settingsHolder.material) {
        if (
          this.settingsHolder.tool.end.indexOf('Ball-Nosed') === -1 &&
          this.settingsHolder.tool.end.indexOf('Chamfer') === -1
        ) {
          this.setHoleDepth(false);
          if (this.Parameters.get('holeDepth').value > this.settingsHolder.tool.lengthOfCut) {
            this.updateHoleDepthField(this.settingsHolder.tool.lengthOfCut);
          }

          this.setHoleDiameter(false);
          this.setHolePitch(false);
        }
      }

      if (toolPath === 'Full Slotting') {
        this.setSlotting(false);
        engagementAngle = 180;
        this.updateCutWidth(stepOver, engagementAngle, false); //updates the ADOC and RDOC
      } else if (toolPath === 'Chamfering') {
        this.setChamferDiameter(false);
        this.updateCutWidth(stepOver, undefined, false); //updates the ADOC and RDOC
      } else if (toolPath) {
        this.setProfile(false, false, setRdoc); //this will call RDOC
        this.updateCutWidth(stepOver, engagementAngle, false); //updates the ADOC and RDOC
      }

      this.updateCutDepth(); // updates and set the stepdown
      this.setProtrude(); // set the stickout
      this.updateHoleDepth(false);

      if (notify) {
        this.emitData();
      }
    }
  };

  calculateStepDown = (
    updateADOC: boolean = true,
    updateCutWidth: boolean = true,
    setRdoc: boolean = true,
    showWarnings: boolean = false
  ) => {
    let stepDown = this.Parameters.get('stepDown').value;
    if (stepDown > 0) {
      if (this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('3d surfacing') > -1) {
        if (stepDown >= 50) {
          let message: Message = {
            title: 'Stepdown too High!',
            message: 'Axial cut depth must less than the radius of the ball nose endmill!'
          };
          if (this.warningAlerts) {
            this.utils.openDialog(message, 'error');
          }
          this.setADOC();
        }

        if (this.Parameters.get('scallopHeight').value > 0) {
          let scallopHeight = this.Parameters.get('scallopHeight').value;
          let scallopWidth = 0;

          if (scallopHeight / 10000 > stepDown * this.settingsHolder.tool.cutterDiameter) {
            scallopHeight = 10000 * stepDown * this.settingsHolder.tool.cutterDiameter;
            scallopWidth =
              math.floor(
                10000 * this.formulas.calculateScallopStepOver(this.settingsHolder.tool.cutterDiameter, scallopHeight)
              ) / 10000;
            this.updateScallopHeight(scallopHeight);
            this.updateScallopWidth(scallopWidth);
          }
        }
      }

      if (
        math.round(this.settingsHolder.tool.lengthOfCut / this.settingsHolder.tool.cutterDiameter, 4) <
        math.round(stepDown / 100, 4)
      ) {
        this.adocSlider['disabled'] = true;
        if (this.warningAlerts) {
          if (showWarnings) {
            // showWarnings is always false, so this warning is never shown. This is possibly related to a bug in the backlog (MILL-584)
            let message: Message = {
              title: 'Stepdown too High!',
              message: 'Axial cut depth must not exceed endmill length of cut!'
            };
            this.utils.openDialog(message, 'error', () => {
              stepDown = (100 * this.settingsHolder.tool.lengthOfCut) / this.settingsHolder.tool.cutterDiameter;
              this.updateStepDown(stepDown);
              this.adocReset();
              this.matchSliderToStepDown(stepDown);
              this.adocSlider['disabled'] = false;
            });
          } else {
            this.adocSlider['disabled'] = false;
            stepDown = (100 * this.settingsHolder.tool.lengthOfCut) / this.settingsHolder.tool.cutterDiameter;
            this.updateStepDown(stepDown);
            this.matchSliderToStepDown(stepDown);
          }
        }
      }

      if (updateADOC) {
        this.updateADOC((stepDown * this.settingsHolder.tool.cutterDiameter) / 100);
      }
      if (setRdoc) {
        this.setRDOC(undefined, updateCutWidth);
      }
    }
  };

  finMessage = (cutWidthType: CutWidthType, cutWidthValue: number): number => {
    let fixedCutWidth: number;
    switch (cutWidthType) {
      case CutWidthType.RADIAL_CUT_DEPTH:
        fixedCutWidth = cutWidthValue;
        break;

      case CutWidthType.STEPOVER:
        fixedCutWidth = (this.settingsHolder.tool.cutterDiameter * cutWidthValue) / 100;
        break;

      case CutWidthType.ENGAGEMENT_ANGLE:
        fixedCutWidth = this.conversionFormulas.convertTeaToRdoc(
          cutWidthValue,
          this.settingsHolder.tool.cutterDiameter
        );
        break;
    }

    if (1.5 * this.formulas.calculateFinishWallStock(this.settingsHolder.tool.cutterDiameter) < fixedCutWidth) {
      fixedCutWidth = this.formulas.calculateFinishWallStock(this.settingsHolder.tool.cutterDiameter);

      let message: Message = {
        title: `Your ${cutWidthType} is too high for finishing!`,
        message: 'Would you like to change your tool path to HEM?'
      };

      if (this.warningAlerts && !this.finMessageWarning) {
        this.finMessageWarning = true;
        this.utils.openDialog(
          message,
          'confirm',
          () => {
            this.finMessageWarning = false;

            this.commonService.notifyOther({
              option: 'changeToolPath',
              value: 'High Efficiency Milling'
            });
            //need to report back to container to let operation know
            this.cutWidth = this.Parameters.get('rdocdecimal').value;
            // need to set slider to correct position
            this.matchSliderToStepDown(this.Parameters.get('stepDown').value);
            this.setProfile(true, false);
          },
          () => {
            this.adocReset();
            this.cutWidth = this.Parameters.get('rdocdecimal').value;
            this.rdocReset();
            this.finMessageWarning = false;
          }
        );
      }
    }
    return this.cutWidth;
  };

  slotMessage = (cutWidthType: string) => {
    if (this.mapMode !== 1) {
      // We don't want this to run if user isn't in map mode 1
      return;
    }
    
    let messageStr = '';
    switch (cutWidthType.toLowerCase()) {
      case 'rdoc':
        messageStr = 'Radial cut depth must be less than endmill diameter!';
        break;

      case 'stepover':
        messageStr = 'Stepover must be less than 100%!';
        break;

      case 'engagement angle':
        messageStr = 'Engagement angle must be less than 180°!';
        break;
    }

    messageStr = messageStr + ' Would you like to change the tool path to slotting?';

    let message: Message = {
      title: cutWidthType + ' must be less than endmill diameter!',
      message: messageStr
    };

    if (this.settingsHolder.currenttoolpath.operationName.toLowerCase().indexOf('slotting') < 0) {
      if (this.warningAlerts) {
        this.warningMessageOpen = true;
        this.utils.openDialog(
          message,
          'confirm',
          chose => {
            this.warningMessageOpen = false;
            //need to report back to container to let operation know
            this.commonService.notifyOther({
              option: 'changeToolPath',
              value: 'Full Slotting'
            });
            this.setProfile(true, false);
            this.cutWidth = this.Parameters.get('rdocdecimal').value;
            this.aggressiveFlag = false; // change to slotting to its no longer aggressive
          },
          chose => {
            this.warningMessageOpen = false;
            //need to report back to container to let operation know
            this.setProfile(true, false);
            this.cutWidth = this.Parameters.get('rdocdecimal').value;
            this.warningAlerts = true;
            this.aggressiveFlag = false;
            setTimeout(() => {
              this.defaultSliderADOCDisabled = true;
              this.defaultSliderRDOCDisabled = true;
            });
            this.adocReset();
            this.setRDOC();
          }
        );
      }
    }
  };

  updateHoleDepth = (notify: boolean = true) => {
    let holeDepth = this.Parameters.get('holeDepth').value;
    if (holeDepth > 0) {
      //might have to update the adoc slider
      if (this.settingsHolder.currenttoolpath.operationName === 'Helical Plunge') {
        this.adocMax = (this.adocMax * holeDepth) / this.settingsHolder.tool.lengthOfCut;
      }
    }
    if (notify) {
      this.emitData();
    }
  };

  maxRDOCmessage = () => {
    if (this.mapMode !== 1) {
      // We don't want this to run if user isn't in map mode 1
      return;
    }

    // cautionRDOC.Visible = false; we might have to add a caution icon somewhere
    let toolEngAng = this.Parameters.get('engagementAngle').value;
    let minEngAng = 17.5 - (90 * this.settingsHolder.tool.rake) / math.PI;
    if (toolEngAng < minEngAng) {
      let messageStr = 'Your radial depth of cut is too low and';
      messageStr = messageStr + ' may cause the tool to rub instead of cut.';
      let message: Message = {
        title: 'RDOC too Low',
        message: messageStr
      };
      if (this.warningAlerts) {
        this.utils.openDialog(message, 'error');
      }
      this.setProfile(true, false);
    } else {
      let roundFactor = this.formulas.emRoundFactor(this.settingsHolder.tool.cutterDiameter);
      let radDepth = this.Parameters.get('rdocdecimal').value;
      let axDepth = math.round(this.Parameters.get('adocdecimal').value, 3);
      let maxEngageAng = this.formulas.calculateMaxEngageAngle(
        this.settingsHolder.tool,
        axDepth,
        this.settingsHolder.material,
        this.settingsHolder.hardness.hra
      );
      let maxRdoc =
        roundFactor *
        math.round(
          this.conversionFormulas.convertTeaToRdoc(maxEngageAng, this.settingsHolder.tool.cutterDiameter) / roundFactor,
          2
        );
      this.maxRDOC = maxRdoc;

      let messageStr = 'The current parameters may cause catastrophic tool failure. ';
      messageStr = messageStr + 'Be mindful of chip evacuation when using a radial depth of cut ';
      messageStr = messageStr + 'that exceeds ' + maxRdoc + '\x22 for this tool and setup.';
      let filletRadius = 0;
      if (this.settingsHolder.recommendationFields === 2 || this.settingsHolder.recommendationFields === 1) {
        if (this.settingsHolder.recommendationForm) {
          if (this.settingsHolder.recommendationFields === 2) {
            filletRadius = this.settingsHolder.recommendationForm.get('type2').get('trochoidalSlotWidth').value / 2;
          } else {
            filletRadius = this.settingsHolder.recommendationForm.get('type1').get('insideCornerRadiusOfWall').value;
          }
        }
        if (!isNaN(filletRadius)) {
          messageStr = 'The current parameters may cause catastrophic tool failure.<br />';
          
          if (this.maxRDOC > 0) {
            messageStr = `${messageStr}Be mindful of chip evacuation when using a radial depth of cut that exceeds: ${this.maxRDOC} for this tool and setup<br />`;
          }

          //TODO: Adding back in the reworked logic from PO for the minimum wall width/min slot width

          if (
            radDepth > this.maxRDOC ||
            (this.currentPath === 'Trochoidal Slotting' && this.Parameters.get('engagementAngle').value >= 180)
          ) {
            if (this.warningAlerts && !this.aggressiveFlag) {
              this.aggressiveFlag = true;
              this.sliderDisabled = true;
              this.sliderRdocDisabled = true;
              let message: Message = {
                title: 'Warning!',
                message: messageStr
              };
              this.utils.openDialog(
                message,
                'error',
                () => {
                  this.sliderDisabled = false;
                  this.sliderRdocDisabled = false;
                },
                () => {
                  this.sliderDisabled = false;
                  this.sliderRdocDisabled = false;
                }
              );
            }
          } else {
            this.aggressiveFlag = false;
            this.sliderDisabled = this.adocLocked;
            this.sliderRdocDisabled = this.rdocLocked;
          }
        }
      } else {
        if (radDepth > this.maxRDOC) {
          if (
            this.settingsHolder.tool &&
            this.settingsHolder.machine &&
            this.settingsHolder.currenttoolpath &&
            this.settingsHolder.material
          ) {
            if (this.settingsHolder.material['chosenCondition']) {
              if (this.warningAlerts && !this.aggressiveFlag) {
                this.aggressiveFlag = true;
                this.sliderDisabled = true;
                this.sliderRdocDisabled = true;
                let message: Message = {
                  title: 'Catastrophic tool failure!',
                  message: messageStr
                };
                this.utils.openDialog(
                  message,
                  'error',
                  () => {
                    this.sliderDisabled = false;
                    this.sliderRdocDisabled = false;
                  },
                  () => {
                    this.sliderDisabled = false;
                    this.sliderRdocDisabled = false;
                  }
                );
              }
            }
          }
        } else {
          this.aggressiveFlag = false;
          this.sliderDisabled = this.adocLocked;
          this.sliderRdocDisabled = this.rdocLocked;
        }
      }
    }
  };

  toolSwap = () => {
    this.mapMode = this.settingsHolder.mapMode;
    let toolEnd = this.settingsHolder.tool.end;
    let millBit = undefined;
    this.toolImage = '';
    this.toolImageHeight = 0;

    if (this.settingsHolder.tool.toolImageUrl.length > 0) {
      this.toolImage = this.settingsHolder.tool.toolImageUrl;
    } else {
      if (toolEnd.indexOf('Ball-Nosed') > -1) {
        millBit = this.constants.getMillBitByName('Ball-Nosed');
      } else if (toolEnd.indexOf('Square') > -1) {
        millBit = this.constants.getMillBitByName('Square');
      } else if (toolEnd.indexOf('Chamfer') > -1) {
        millBit = this.constants.getMillBitByName('Chamfer');
      } else if (toolEnd.indexOf('Bull-Nosed') > -1) {
        millBit = this.constants.getMillBitByName('Bull-Nosed');
      } else {
        millBit = this.imageConstants.unavailableToolImage;
      }

      if (millBit) {
        this.toolImage = millBit.getImage();
        this.toolImageHeight = this.isApp ? millBit.getMobilePercentageHeight() : millBit.getPercentHeight();
        this.toolImageWidth = this.isApp ? millBit.getMobilePercentageWidth() : millBit.getPercentWidth();
      }
    }
  };

  navigateToPage = url => {
    if (this.isApp) {
      cordova.InAppBrowser.open(url, '_system');
    } else {
      window.open(url);
    }
  };
}
